import React, { useState } from 'react'
import { FileUploader } from 'react-drag-drop-files'
import defaultUser from '@/assets/images/default-user.webp'
import { Button } from 'antd'
import { CloseCircleOutlined } from '@ant-design/icons'
import { IFile } from '@/core/typing'
import editIcon from '@/assets/images/edit.svg'
import styles from './styles.module.css'

interface IProps {
    avatarUrl: string

    onChangeFile: (file: File) => void
    clear: () => void
    value: IFile
    disabled?: boolean
    style?: React.CSSProperties
}

export const UploadPhoto = ({
    onChangeFile,
    style,
    clear,
    disabled,
    avatarUrl,
}: IProps) => {
    const [hovered, setHovered] = useState(false)

    const fileTypes = ['JPEG', 'PNG', 'GIF', 'JPG']

    const handlerCrear = () => {
        clear()
    }

    const handleMouseEnter = () => {
        setHovered(true)
    }

    const handleMouseLeave = () => {
        setHovered(false)
    }
    return (
        <div
            style={{ position: 'relative', opacity: disabled ? 0.7 : 1 }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}>
            {hovered && avatarUrl && !disabled ? (
                <Button
                    disabled={disabled}
                    onClick={handlerCrear}
                    type='text'
                    className={styles.cross}
                    icon={
                        <CloseCircleOutlined
                            style={{ color: 'red', fontSize: 15 }}
                        />
                    }
                />
            ) : null}
            <FileUploader
                disabled={disabled}
                multiple={true}
                handleChange={(val: any) => onChangeFile(val[0])}
                name='file'
                types={fileTypes}>
                <div
                    style={{
                        ...style,
                        cursor: disabled ? 'not-allowed' : 'pointer',
                    }}>
                    <img
                        className={styles.def_user}
                        src={avatarUrl || defaultUser}
                        alt='user photo'
                    />
                    <div className={styles.edit}>
                        <img src={editIcon} style={{ height: 24, width: 24 }} />
                    </div>
                </div>
            </FileUploader>
        </div>
    )
}
